import React from "react";
import useProductName from "brand-customization/useProductName";
import { LinkContainer, DocumentTitle, PageHeader } from "components/common";
import withParams from "routing/withParams";
import { Button, Col, Row } from "components/bootstrap";
import ForwarderDocs from "forwarder/util/ForwarderDocs";
import withIsPermitted from "forwarder/util/withIsPermitted";
import useSendTelemetry from "logic/telemetry/useSendTelemetry";
import { TELEMETRY_EVENT_TYPE } from "telemetry/Constants";
import ForwarderRoutes from "forwarder/Routes";
import ForwarderWizard from "./ForwarderWizard";
const REQUIRED_PERMISSIONS = [
  "forwarders:create",
  "forwarders:edit",
  "forwarders:read",
  "inputprofiles:create",
  "inputprofiles:edit",
  "inputprofiles:read",
  "forwarderinputs:create",
  "forwarderinputs:edit",
  "forwarderinputs:read"
];
const ForwarderWizardPage = ({ params }) => {
  const productName = useProductName();
  const pageHeader = params && params.forwarderId ? "Configure Forwarder" : "New Forwarder";
  const sendTelemetry = useSendTelemetry("forwarder-wizard");
  const onForwarderSetupExit = () => {
    sendTelemetry(TELEMETRY_EVENT_TYPE.FORWARDER.FORWARDER_WIZARD_SETUP_CANCELED, {
      app_pathname: "forwarder"
    });
  };
  return /* @__PURE__ */ React.createElement(DocumentTitle, { title: pageHeader }, /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(
    PageHeader,
    {
      title: pageHeader,
      documentationLink: {
        title: "Forwarder documentation",
        path: ForwarderDocs.FORWARDER
      },
      actions: /* @__PURE__ */ React.createElement(LinkContainer, { onClick: () => onForwarderSetupExit(), to: ForwarderRoutes.LIST }, /* @__PURE__ */ React.createElement(Button, { bsStyle: "info" }, "Exit Forwarder Setup"))
    },
    /* @__PURE__ */ React.createElement("span", null, "Set up a Forwarder to start sending data into ", productName, ".")
  ), /* @__PURE__ */ React.createElement(Row, { className: "content" }, /* @__PURE__ */ React.createElement(Col, { md: 12 }, /* @__PURE__ */ React.createElement(ForwarderWizard, { forwarderId: params && params.forwarderId })))));
};
export default withParams(withIsPermitted(ForwarderWizardPage, REQUIRED_PERMISSIONS));
